<template>
  <!-- Sidebar -->
  <div class="flex h-screen overflow-y-hidden">
    <aside
        v-if="!isInGameMode()"
        class="bg-blue-50 border-gray-200  fixed inset-y-0 z-10 flex flex-col flex-shrink-0 w-64 max-h-screen overflow-hidden transition-all transform border-r shadow-lg lg:z-auto lg:static lg:shadow-none"
        :class="{'-translate-x-full lg:translate-x-0 lg:w-20': !isSidebarOpen}"
    >
      <!-- sidebar header -->
      <div class="flex items-center justify-between flex-shrink-0 p-2 " :class="{'lg:justify-center': !isSidebarOpen}">
        <div class="p-2 text-xl font-semibold leading-8 cursor-pointer tracking-wider whitespace-nowrap"
             @click="goToLanding">
          <img src="/images/logo.png" class="float-left h-8 mr-2 flex"/><span :class="{'lg:hidden': !isSidebarOpen}">AgileSuite.io</span>
        </div>
        <button @click="toggleSidbarMenu()" class="p-2 rounded-full bg-blue-200  lg:hidden">
          <svg
              class="w-6 h-6 text-red-400"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
          >
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
          </svg>
        </button>
      </div>

      <div class="px-2" v-if="isSidebarOpen">

        <div
            class="flex bg-blue-50 items-center space-x-3 px-3 py-2 text-sm text-left font-medium cursor-pointer rounded-md hover:bg-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-100 focus:ring-purple-500">
          <div class="flex-shrink-0 h-12 w-12">
            <img class="h-12 w-12 rounded-full"
                 :src="$page.props.user.profile_photo_path"
                 alt=""/>
          </div>
          <div class="space-y-1">
            <div class="text-sm font-medium text-gray-900 flex">

              {{ $page.props.user.name }}

              <a-tooltip v-if=" $page.props.user.email_verified_at === null" placement="bottom">
                <template #title>
                  <span> Unverified Account</span>
                </template>
                <XCircleIcon class="inline-flex items-center  mr-1.5 h-5 w-5 text-red-400" aria-hidden="true"/>
              </a-tooltip>
              <a-tooltip v-else placement="bottom">
                <template #title>
                  <span> Verified Account</span>
                </template>
                <CheckCircleIcon class="inline-flex items-center  mr-1.5 h-5 w-5 text-green-400"
                                 aria-hidden="true"/>
              </a-tooltip>

              <a-tooltip v-if=" $page.props.user.is_vip === true" placement="bottom">
                <template #title>
                  <span>VIP</span>
                </template>
                <StarIcon class="inline-flex items-center  mr-1.5 h-5 w-5 text-yellow-400"
                          aria-hidden="true"/>
              </a-tooltip>
            </div>
            <div class="group flex items-center space-x-2.5">
              <span class="text-sm break-all text-gray-400 font-semibold mb-1">  {{ $page.props.user.email }}</span>
            </div>
            <div v-if="$page.props.user.is_paid"
                 class="inline-flex items-baseline px-2.5 py-0.5 rounded-full text-sm font-medium md:mt-2 lg:mt-0 bg-green-100 text-green-800">
              Premium
            </div>
            <a v-else href="/settings/subscriptions"
               class="focus:outline-none shadow-lg rounded-md bg-yellow-400 hover:bg-yellow-300 text-black text-sm mt-5 px-2  font-bold mr-2 font-bold border-b-4 border-orange-500 hover:border-orange-300 rounded-full">
              Upgrade
            </a>
          </div>
        </div>
        <div
            class="flex bg-blue-50 items-center space-x-3 px-3 py-2 text-sm text-left font-medium  rounded-md">
          <team-selection-dropdown></team-selection-dropdown>
        </div>
      </div>
      <nav aria-label="Main" class="flex-1 w-64 px-2 py-4 space-y-2 overflow-y-auto hover:overflow-y-auto">
        <!-- Dashboards links -->
        <div v-for="item in navigation2">
          <!-- active & hover classes 'bg-indigo-100 dark:bg-indigo-600' -->
          <a
              :href="item.url"
              @click="item.is_sub_tabs !== false ? openClickMainTab(item) : null"
              class="flex items-center p-2 text-gray-500 transition-colors rounded-md dark:text-light hover:bg-white"
              :class="{'bg-white': item.current}"
              role="button"
              aria-haspopup="true"
              :aria-expanded="(item.current) ? 'true' : 'false'"
          >
             <span v-html="item.icon"
                   :class="[item.current ? 'text-gray-500' : 'text-gray-400 group-hover:text-gray-500', 'mr-3 flex-shrink-0']"
                   aria-hidden="true"/>


            <span class="ml-1 font-bold text-gray-600" v-if="isSidebarOpen"> {{ item.name }} </span>
            <span v-if="isSidebarOpen" class="ml-auto" aria-hidden="true">
                  <!-- active class 'rotate-180' -->
                  <svg
                      v-if="item.is_sub_tabs !== false"
                      class="w-4 h-4 transition-transform transform"
                      :class="{ 'rotate-180': !item.current }"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                  >
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/>
                  </svg>
                </span>

          </a>


          <div role="menu" v-if="item.current && isSidebarOpen" class="mt-2 space-y-2 px-12" aria-label="Dashboards">


            <!-- active & hover classes 'text-gray-700 dark:text-light' -->
            <!-- inActive classes 'text-gray-400 dark:text-gray-400' -->

            <template v-for="tab in item.tabs">
              <a
                  @click="tab.is_sub  ? tab.current = !tab.current : tab.is_locked ? createTeam(): gotToNewTab(tab);"
                  href="#"
                  role="menuitem"
                  class="flex items-center block p-2 text-sm transition-colors duration-200 rounded-md hover:text-black"
                  :class="tab.current && !tab.is_sub  ? 'text-black font-bold': 'text-gray-500' "
              >
                <template v-if="!tab.is_locked"><span>{{ tab.name }}</span></template>

                <template v-else>


                  <a-tooltip placement="right">
                    <template #title>
                      Select a team or create a team first before accessing the team feature
                    </template>
                    <span class="inline-block">{{ tab.name }}</span>
                    <span class="inline-block" aria-hidden="true">
                   <LockClosedIcon class="w-4 h-4 text-red-400 font-bold"></LockClosedIcon>
                    </span>
                  </a-tooltip>
                  <!-- active class 'rotate-180' -->
                </template>


                <span v-if="isSidebarOpen && tab.is_sub" class="ml-auto" aria-hidden="true">
                  <!-- active class 'rotate-180' -->
                  <svg
                      class="w-4 h-4 transition-transform transform"
                      :class="{ 'rotate-180': !tab.current }"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                  >
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/>
                  </svg>
                </span>
              </a>

              <div role="menu" v-if="tab.current && isSidebarOpen" class="mt-2 space-y-2 px-4" aria-label="Dashboards">
                <a
                    @click="this.$inertia.visit(subTab.url)"
                    v-for="subTab in tab.sub_tabs"
                    href="#"
                    role="menuitem"
                    class="flex items-center block p-2 text-sm transition-colors duration-200 rounded-md hover:text-black"
                    :class="subTab.current ? 'text-black font-bold': 'text-gray-500' "
                >
                  <span>{{ subTab.name }}</span>

                  <span v-if="isSidebarOpen" class="ml-auto" aria-hidden="true">
                </span>
                </a>
              </div>

            </template>


          </div>

        </div>

      </nav>

    </aside>

    <div class="flex flex-col flex-1 h-full overflow-hidden bg-gray-100">
      <!-- Navbar -->
      <header class="flex-shrink-0 border-b">
        <div
            v-if="$page.props.env !== 'production'"
            class="text-center font-bold bg-red-100 border-red-500 text-orange-700 p-4"
            role="alert"
        >
          <p>Please use our production server agilesuite.io, our staging server may have a lot bugs and unstable
            services.</p>
        </div>
        <div
            v-if="$page.props.user && !$page.props.user.is_temp_user && $page.props.user.email_verified_at == null"
            class="text-center bg-orange-100 border-orange-500 text-orange-700 p-4"
            role="alert"
        >
          <p>Your account is not verified, please verify it or click <a class="cursor-pointer text-blue-400"
                                                                        @click="this.$inertia.visit(route('profile.show'))">here </a>
            to resend verification.</p>
        </div>
        <div class="flex items-center justify-between"
             :class="isInGameMode() ? '': 'p-2'">
          <!-- Navbar left -->
          <div class="flex items-center space-x-3">
            <span class="p-2 text-xl font-semibold tracking-wider uppercase"
                  :class="{'lg:invisible': isInGameMode() && isSidebarOpen, 'lg:hidden':  !isInGameMode() }">
               <button class="block h-8 w-auto" @click="goToLanding()">
                  <img src="/images/logo.png" class="float-left h-8 mr-2 flex" @click="goToLanding()"/><label
                   @click="goToLanding()" class="flex float-right text-lg"
               ><a class="text-gray-800" @click="goToLanding()">Agile</a><a class="text-gblack font-bold"
                                                                            @click="goToLanding()">Suite.io</a></label
               >
                </button>
            </span>
            <!-- Toggle sidebar button -->
            <button v-if="!isInGameMode()" @click="toggleSidbarMenu()"
                    class="p-2 rounded-full bg-gray-200 focus:outline-none focus:ring hover:bg-white">
              <ChevronRightIcon class="h-6 w-6" :class="{'transform transition-transform -rotate-180': isSidebarOpen}"
                                aria-hidden="true"/>
              <!--              <svg-->
              <!--                  class="w-4 h-4 text-gray-600"-->
              <!--                  :class="{'transform transition-transform -rotate-180': isSidebarOpen}"-->
              <!--                  xmlns="http://www.w3.org/2000/svg"-->
              <!--                  fill="none"-->
              <!--                  viewBox="0 0 24 24"-->
              <!--                  stroke="currentColor"-->
              <!--              >-->
              <!--                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 5l7 7-7 7M5 5l7 7-7 7"/>-->
              <!--              </svg>-->
            </button>

            <button @click="this.$inertia.visit(route('dashboard'));"
                    class="p-2 rounded-full bg-gray-200 focus:outline-none focus:ring hover:bg-white">
              <HomeIcon class="h-6 w-6" aria-hidden="true"/>
            </button>


            <Menu as="div" class="relative inline-block text-left">
              <div>
                <MenuButton
                    class="p-2 rounded-full bg-gray-200 focus:outline-none focus:ring hover:bg-white rounded-full flex items-center text-gray-400 hover:text-gray-600">
                  <span class="sr-only">Open options</span>
                  <ViewGridIcon class="w-6 h-6 text-black" aria-hidden="true"/>
                </MenuButton>
              </div>

              <transition enter-active-class="transition ease-out duration-100"
                          enter-from-class="transform opacity-0 scale-95"
                          enter-to-class="transform opacity-100 scale-100"
                          leave-active-class="transition ease-in duration-75"
                          leave-from-class="transform opacity-100 scale-100"
                          leave-to-class="transform opacity-0 scale-95">
                <MenuItems
                    class="z-50 origin-top-left absolute left-0 mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none">
                  <div class="py-1">
                    <MenuItem v-slot="{ active }">

                      <a href="/landing/retro" target="_blank"
                         :class="[active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'block px-4 py-2 text-sm']">
                        <img class="w-8 h-8 inline-block mr-2" src="/images/retro.svg"
                        />
                        Retrospective</a>
                    </MenuItem>
                    <MenuItem v-slot="{ active }">
                      <a href="/landing/poker" target="_blank"
                         :class="[active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'block px-4 py-2 text-sm']">
                        <img class="w-8 h-8 inline-block mr-2" src="/images/poker.svg"
                        />
                        Planning Poker</a>
                    </MenuItem>
                    <MenuItem v-slot="{ active }">
                      <a href="/landing/report" target="_blank"
                         :class="[active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'block px-4 py-2 text-sm']"
                         @click="this.$inertia.visit(route('report.public.reports'))">
                        <img class="w-8 h-8 inline-block mr-2" src="/images/report.svg"
                        />
                        Async Report
                      </a>
                    </MenuItem>
                  </div>
                </MenuItems>
              </transition>
            </Menu>
            <trustpilot-feedback :topic="route().current()" ></trustpilot-feedback>
            <!--            <feedback :topic="route().current()" :is-bottom="false"></feedback>-->
            <a href="https://www.producthunt.com/posts/agilesuite-io?utm_source=badge-featured&utm_medium=badge&utm_souce=badge-agilesuite&#0045;io"
               target="_blank"><img
                src="https://api.producthunt.com/widgets/embed-image/v1/featured.svg?post_id=368613&theme=light"
                alt="AgileSuite&#0046;io - retrospective&#0044;&#0032;planning&#0032;poker&#0044;&#0032;standup&#0044;&#0032;scrum | Product Hunt"
                style="width: 200px; height: 45px;" width="250" height="54"/></a>
            <button
                class="
          focus:outline-none
          text-lg
          hover:bg-indigo-200
          font-bold
          text-black
          rounded-full
          p-2
          bg-indigo-300
          z-50
        "
                @click="gotToBilling()"
                v-if="!($page.props.user.is_team_paid || $page.props.user.is_paid)"
            >
              ✨ Upgrade
            </button>
          </div>
          <!--          <div v-if="isInGameMode()" class="items-center hidden  mx-auto space-x-4 md:flex-1 md:flex md:mr-auto md:ml-5">-->
          <!--            <img src="/images/retro.svg" @click="this.$inertia.visit(route('retro.public.board.list'))"-->
          <!--                 class="ml-4 h-10 w-10"/>-->
          <!--            <img src="/images/report.svg" @click="this.$inertia.visit(route('report.public.reports'))"-->
          <!--                 class="ml-4 h-10 w-10"/>-->
          <!--            <img src="/images/poker.svg" @click="this.$inertia.visit(route('planning-rooms.public-rooms'))"-->
          <!--                 class="ml-4 h-10 w-10"/>-->
          <!--          </div>-->


          <!-- Navbar right -->
          <div class="relative flex items-center space-x-3">


            <div class="items-center hidden space-x-3 md:flex">
              <jet-dropdown align="right" width="60">
                <template #trigger>
                        <span class="inline-flex rounded-md">
                          <button
                              type="button"
                              class="
                              text-md
                              font-extrabold
                              inline-flex
                              items-center
                              px-3
                              py-2
                              border border-transparent
                              text-sm
                              leading-4
                              font-medium
                              rounded-md
                              text-gray-900
                              bg-transparent
                              hover:bg-blue-100
                              hover:text-gray-700
                              focus:outline-none
                              focus:bg-blue-100
                              active:bg-blue-100
                              transition
                            "
                          >
                            <div v-if="$page.props.user.current_team_id">
                              <img
                                  v-if="$page.props.user.current_team.provider === 'slack'"
                                  src="https://cdn.worldvectorlogo.com/logos/slack-new-logo.svg"
                                  alt="slack logo"
                                  class="w-4 h-4 mr-2"
                              />
                    <a-tooltip placement="bottom">
                              <template #title>
                                <span>You are a member of a premium team, means you have access to all the features this team subscribes to.</span>
                              </template>
                                 <div v-if="$page.props.user.is_team_paid"
                                      class="inline-flex items-baseline px-2.5 py-0.5 rounded-full text-sm font-medium md:mt-2 lg:mt-0 bg-green-100 text-green-800">
              Premium Team
            </div>
                            </a-tooltip>

                                <div v-if="!$page.props.user.is_team_paid"
                                     class="inline-flex items-baseline px-2.5 py-0.5 rounded-full text-sm font-medium md:mt-2 lg:mt-0 bg-yellow-100 text-yellow-800">
              Free Team
            </div>
                                {{ $page.props.user.current_team.name }}
                            </div>

                            <div v-else>Select a team</div>


                            <svg class="ml-2 -mr-0.5 h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                                 fill="currentColor">
                              <path
                                  fill-rule="evenodd"
                                  d="M10 3a1 1 0 01.707.293l3 3a1 1 0 01-1.414 1.414L10 5.414 7.707 7.707a1 1 0 01-1.414-1.414l3-3A1 1 0 0110 3zm-3.707 9.293a1 1 0 011.414 0L10 14.586l2.293-2.293a1 1 0 011.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z"
                                  clip-rule="evenodd"
                              />
                            </svg>
                          </button>
                        </span>
                </template>

                <template #content>
                  <div class="w-60">
                    <!-- Team Management -->

                    <div class="block px-4 py-2 text-xs text-gray-400">Manage Team</div>

                    <!-- Team Settings -->
                    <jet-dropdown-link v-if="$page.props.user.current_team_id"
                                       :href="route('teams.show', $page.props.user.current_team_id)">
                      Team Settings
                    </jet-dropdown-link>


                    <jet-dropdown-link
                        v-if="$page.props.jetstream.canCreateTeams"
                        :href="route('teams.create')"
                    >
                      Create New Team
                    </jet-dropdown-link>

                    <div class="border-t border-gray-100"></div>

                    <!-- Team Switcher -->
                    <div class="block px-4 py-2 text-xs text-gray-400">Switch Teams</div>

                    <template v-for="team in $page.props.user.all_teams" :key="team.id">
                      <form @submit.prevent="switchToTeam(team)">
                        <jet-dropdown-link as="button">
                          <div class="flex items-center">
                            <svg
                                v-if="team.id == $page.props.user.current_team_id"
                                class="mr-2 h-5 w-5 text-green-400"
                                fill="none"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                            >
                              <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                            </svg>
                            <div class="flex">
                              {{ team.name }}
                              <img
                                  v-if="team.provider === 'slack'"
                                  src="https://cdn.worldvectorlogo.com/logos/slack-new-logo.svg"
                                  alt="slack logo"
                                  class="w-4 h-4 ml-2"
                              />
                            </div>
                          </div>
                        </jet-dropdown-link>
                      </form>
                    </template>
                  </div>
                </template>
              </jet-dropdown>
            </div>

            <!-- avatar button -->
            <div class="relative">
              <jet-dropdown align="right" width="48">
                <template #trigger>
                  <!--                      <button-->
                  <!--                          class="-->
                  <!--                          flex-->
                  <!--                          text-sm-->
                  <!--                          border-2 border-transparent-->
                  <!--                          rounded-full-->
                  <!--                          focus:outline-none-->
                  <!--                          focus:border-gray-300-->
                  <!--                          transition-->
                  <!--                        "-->
                  <!--                      >-->
                  <!--                        <img-->
                  <!--                            class="h-8 w-8 rounded-full object-cover"-->
                  <!--                            :src="$page.props.user.profile_photo_url"-->
                  <!--                            :alt="$page.props.user.name"-->
                  <!--                        />-->
                  <!--                      </button>-->

                  <span class="inline-flex rounded-md">
                          <button
                              type="button"
                              class="
                              inline-flex
                              items-center
                              px-3
                              py-2
                              border border-transparent
                              text-sm
                              leading-4
                              font-medium
                              rounded-md
                              text-gray-900 text-md
                              font-bold
                              bg-transparent
                              hover:text-gray-700
                              focus:outline-none
                              transition
                            "
                          >
                            <label class="text-red-400">{{
                                $page.props.user.email_verified_at == null ? "(Unverified)" : ""
                              }} </label>
                            {{ $page.props.user.name }}

                            <svg class="ml-2 -mr-0.5 h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                                 fill="currentColor">
                              <path
                                  fill-rule="evenodd"
                                  d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                                  clip-rule="evenodd"
                              />
                            </svg>
                          </button>
                        </span>
                </template>

                <template #content>
                  <!-- Account Management -->
                  <div class="block px-4 py-2 text-xs text-gray-400">Manage Account</div>

                  <jet-dropdown-link :href="route('profile.show')"> Profile</jet-dropdown-link>

                  <jet-dropdown-link href="/billing" as="a"> Billing</jet-dropdown-link>

                  <div class="border-t border-gray-100"></div>

                  <!-- Authentication -->
                  <form @submit.prevent="logout">
                    <jet-dropdown-link as="button"> Log Out</jet-dropdown-link>
                  </form>
                </template>
              </jet-dropdown>

            </div>
          </div>
        </div>
      </header>
      <!-- Main content -->
      <main class="flex-1 max-h-full p-5 overflow-hidden overflow-y-scroll">
        <!-- Main content header -->
        <!--        <div-->
        <!--            class="flex flex-col items-start justify-between pb-6 space-y-4 border-b lg:items-center lg:space-y-0 lg:flex-row"-->
        <!--        >-->
        <!--          <h1 class="text-2xl font-semibold whitespace-nowrap">Dashboard</h1>-->
        <!--        </div>-->

        <slot></slot>
      </main>
      <!-- Main footer -->
      <!--      <footer-->
      <!--          class="flex items-center text-sm justify-end flex-shrink-0  text-gray-500 font-bold p-4 border-t max-h-10">-->
      <!--        <div>AgileSuite.io &copy; 2019 - 2021</div>-->
      <!--      </footer>-->
    </div>
  </div>
</template>

<script>
import JetApplicationMark from "@/Jetstream/ApplicationMark";
import JetBanner from "@/Jetstream/Banner";
import JetDropdown from "@/Jetstream/Dropdown";
import JetDropdownLink from "@/Jetstream/DropdownLink";
import JetNavLink from "@/Jetstream/NavLink";
import JetResponsiveNavLink from "@/Jetstream/ResponsiveNavLink";
import ConfirmationModal from "@/Jetstream/ConfirmationModal";
import Modal from "@/Jetstream/Modal";
import DialogModal from "@/Jetstream/DialogModal";
import SecondaryButton from "@/Jetstream/SecondaryButton";
import SignInWithSlackButton from "@/Components/SocialButton/SignInWithSlackButton";
import SignInWithGoogleButton from "@/Components/SocialButton/SignInWithGoogleButton";
import AppFooter from "@/Layouts/AppFooter";
import HeaderBanner from "@/Layouts/HeaderBanner";
import CookieBanner from "@/Layouts/CookieBanner";
import Notification from "@/Components/Notification/Notification";
import RegisterForm from "@/Pages/Auth/RegisterForm";
import LoginForm from "@/Pages/Auth/LoginForm";
import Title from "ant-design-vue/lib/skeleton/Title";
import {ref,} from "vue";
import {
  CalendarIcon,
  ChartBarIcon,
  MenuAlt1Icon,
  FolderIcon,
  HomeIcon,
  InboxIcon,
  MenuIcon,
  UsersIcon,
  LockClosedIcon,
  QuestionMarkCircleIcon,
  ViewGridIcon,
  XIcon,
} from '@heroicons/vue/outline'
import {
  XCircleIcon,
  StarIcon,
  BadgeCheckIcon as CheckCircleIcon,
  ChevronRightIcon,
} from '@heroicons/vue/solid'

const navigation = [
  {name: 'Poker', href: '#', icon: " <img src=\"/images/poker.svg\" class=\"h-8 w-8\"/>", current: false},
  {name: 'Retrospective', href: '#', icon: " <img src=\"/images/retro.svg\" class=\"h-8 w-8\"/>", current: false},
  {name: 'Report', href: '#', icon: " <img src=\"/images/report.svg\" class=\"h-8 w-8\"/>", current: false},
]
import {Menu, MenuButton, MenuItem, MenuItems} from '@headlessui/vue'
import Feedback from "@/Components/Feedback";
import TeamSelectionDropdown from "@/Layouts/TeamSelectionDropdown";
import TrustpilotFeedback from "@/Components/TrustpilotFeedback";

export default {
  components: {
    TrustpilotFeedback,
    TeamSelectionDropdown,
    Feedback,
    Menu, MenuButton, MenuItem, MenuItems,
    StarIcon,
    ChevronRightIcon,
    QuestionMarkCircleIcon,
    ViewGridIcon,
    XCircleIcon,
    CalendarIcon,
    CheckCircleIcon,
    LockClosedIcon,
    ChartBarIcon,
    FolderIcon,
    HomeIcon,
    InboxIcon,
    MenuIcon,
    UsersIcon,
    MenuAlt1Icon,
    XIcon,
    Title,
    LoginForm,
    RegisterForm,
    Notification,
    CookieBanner,
    HeaderBanner,
    AppFooter,
    SignInWithGoogleButton,
    SignInWithSlackButton,
    SecondaryButton,
    DialogModal,
    Modal,
    ConfirmationModal,
    JetApplicationMark,
    JetBanner,
    JetDropdown,
    JetDropdownLink,
    JetNavLink,
    JetResponsiveNavLink,
  },
  props: ['teamId'],
  methods: {
    createTeam() {
      this.$inertia.visit(route('teams.create'))
    },
    gotToNewTab(tab) {
      if (!tab.is_new) {
        this.$inertia.visit(tab.url)
      } else {
        window.open(tab.url, '_blank');
      }

    },
    switchToTeam(team) {
      this.$inertia.put(
          route("current-team.update"),
          {
            team_id: team.id,
          },
          {
            preserveState: false,
          }
      );
    },
    goToLanding() {
      this.$inertia.visit(route('dashboard'));
    },
    gotToBilling() {
      this.$inertia.visit(route('billing.subscriptions'));
    },
    logout() {
      axios.post(this.route("logout"), this.form).then((response) => {
        window.location.reload();
      });
    },
  },
  mounted() {
  },
  beforeMount() {

    const reports = () => {
      //todo
      const isLocked = this.$page.props.user.current_team_id === null;
      return [

        {
          url: route('report.public.reports'),
          is_locked: isLocked,
          name: 'Async Report',
          current: route().current('report.public.reports'),
        },
        {
          url: route('report.public.slack.setting'),
          is_locked: isLocked,
          name: 'Slack Setting',
          current: route().current('report.public.slack.setting'),
        }
      ];
    };

    const pokers = () => {
      //todo
      const isLocked = this.$page.props.user.current_team_id === null;
      return [{
        name: 'Team Rooms',
        is_locked: isLocked,
        url: route('planning-rooms.team-rooms', {id: this.$page.props.user.current_team_id}),
        current: route().current('planning-rooms.team-rooms')
      }];
    };

    const retroTeams = () => {
      const isLocked = this.$page.props.user.current_team_id === null;
      return [
        {
          name: 'Team Boards',
          is_locked: isLocked,
          url: route('retro.team.boards', {id: this.$page.props.user.current_team_id}),
          current: route().current('retro.team.boards')
        },
        {
          name: 'Team Actions',
          is_locked: isLocked,
          url: route('retro.team.actions', {id: this.$page.props.user.current_team_id}),
          current: route().current('retro.team.actions')
        },
        {
          name: 'Team Metrics',
          is_locked: isLocked,
          url: route('retro.team.metrics', {id: this.$page.props.user.current_team_id}),
          current: route().current('retro.team.metrics')
        },
      ];
    }

    const teams = () => {
      if (!this.$page.props.user.current_team_id) {
        return [];
      } else {
        return [
          {
            name: 'Current Team Setting',
            url: route('agile-teams', {id: this.$page.props.user.current_team_id}),
            current: route().current('teams.show')
          }];
      }
    }
    this.navigation2 = ref([
      {
        name: 'Dashboard',
        href: route('dashboard'),
        url: route('dashboard'),
        icon: " <img src=\"/images/dashboard.svg\" class=\"h-8 w-8\"/>",
        current: route().current().includes('dashboard'),
        is_sub_tabs: false
      },
      {
        name: 'Planning Poker',
        href: '#',
        icon: " <img src=\"/images/poker.svg\" class=\"h-8 w-8\"/>",
        current: route().current().includes('planning-rooms'),
        tabs: [
          {
            name: 'Public Rooms',
            url: route('planning-rooms.public-rooms'),
            current: route().current('planning-rooms.public-rooms')
          },
          {
            url: route('planning-rooms.recently-viewed'),
            name: 'Recently Played',
            current: route().current('planning-rooms.recently-viewed')
          },
          ...pokers()
        ]
      },
      {
        name: 'Retrospective',
        href: '#',
        icon: " <img src=\"/images/retro.svg\" class=\"h-8 w-8\"/>",
        current: route().current().includes('retro'),
        tabs: [
          {
            url: route('retro.public.board.list'),
            name: 'Public Boards',
            current: route().current('retro.public.board.list'),
          },
          {
            url: route('retro.public.action.list'),
            name: 'Public Actions',
            current: route().current('retro.public.action.list'),
          },
          ...retroTeams(),
          {
            url: route('retro.flow'),
            name: 'Custom Retro Flow',
            current: route().current('retro.flow'),
          },

        ]
      },
      {
        name: 'Async Report',
        href: '#',
        icon: " <img src=\"/images/report.svg\" class=\"h-8 w-8\"/>",
        current: route().current().includes('report'),
        tabs: [
          ...reports()
        ]
      },
      {
        name: 'Agile Games',
        href: '#',
        icon: " <img src=\"/images/games.svg\" class=\"h-8 w-8\"/>",
        current: route().current().includes('lucky-shuffle'),
        tabs: [
          {
            url: route('lucky-shuffle.index'),
            name: 'Lucky Pick',
            current: route().current('lucky-shuffle.index'),
          },
        ]
      },
      {
        name: 'Team Management',
        href: '#',
        icon: " <img src=\"/images/team.svg\" class=\"h-8 w-8\"/>",
        current: route().current().includes('teams'),
        tabs: [
          {
            url: route('teams.create'),
            name: 'Create Team',
            current: route().current('teams.create'),
          },
          ...teams(),
        ]
      },
      {
        name: 'Billing Management',
        href: '#',
        icon: " <img src=\"/images/pricing.svg\" class=\"h-8 w-8\"/>",
        current: route().current().includes('billing'),
        tabs: [
          {
            url: route('billing.setting'),
            name: 'Receipts',
            current: route().current('billing.setting'),
          },
          {
            url: route('billing.seats'),
            name: 'Seat Usage',
            current: route().current('billing.seats'),
          },
          {
            url: route('billing.subscriptions'),
            name: 'Choose your plan',
            // is_new: true,
            current: route().current('billing.subscriptions'),
          },
          {
            url: '/billing',
            name: 'Manage your plan',
            is_new: true,
            current: route().current('agile.billing'),
          }
        ]
      }
      // {
      //   name: 'Billing',
      //   href: '#',
      //   icon: " <img src=\"/images/billing.svg\" class=\"h-8 w-8\"/>",
      //   current: false,
      //   tabs: [
      //     {
      //       url: route('planning-rooms.public-rooms'),
      //       name: 'My Rooms',
      //       current: false,
      //     },
      //     {
      //       url: route('planning-rooms.public-rooms'),
      //       name: 'Recently Viewed',
      //       current: false,
      //     }
      //   ]
      // },
    ]);
  },
  data() {
    return {
      navigation2: []
    }
  },
  setup() {

    const isInGameMode = () => {
      return route().current('planning-rooms.accessRoom') || route().current('retrospective.accessRoom');
    }
    const loading = ref(false);
    const isSidebarOpen = ref(!isInGameMode());
    const isSettingsPanelOpen = ref(false);
    const isOpen = ref(false);
    const toggleSidbarMenu = () => {
      isSidebarOpen.value = !isSidebarOpen.value;
    }
    const openClickMainTab = (item) => {
      item.current = !item.current;
      if (item.current) {
        isSidebarOpen.value = true;
      }
    }
    return {
      openClickMainTab,
      isOpen,
      loading,
      isInGameMode,
      navigation,
      isSidebarOpen,
      toggleSidbarMenu,
      isSettingsPanelOpen,
    }
  }

};
</script>
